import { render, staticRenderFns } from "./UsersPrivilegeHistoricalPlans.vue?vue&type=template&id=333104fa&scoped=true&"
import script from "./UsersPrivilegeHistoricalPlans.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeHistoricalPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333104fa",
  null
  
)

export default component.exports